import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ThemeTemplateToken } from '@sleed/bizcommerce-api';
import { themeTemplatesApi } from '~/lib/api/client';
import { formToToken, type ThemeTemplateFormValues } from '~/lib/schemas/theme-template';

export const themeTemplateKeys = {
	all: ['theme-templates'] as const,
	list: () => [...themeTemplateKeys.all, 'list'] as const
};

export function useThemeTemplatesList() {
	return useQuery<ThemeTemplateToken[]>({
		queryKey: themeTemplateKeys.list(),
		queryFn: async () => (await themeTemplatesApi.getAll()).data.items ?? []
	});
}

export function useThemeTemplateMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: themeTemplateKeys.list() });
	const create = useMutation({
		mutationFn: async (form: ThemeTemplateFormValues) => (await themeTemplatesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: ThemeTemplateFormValues) => (await themeTemplatesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await themeTemplatesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
